import { ButtonBase, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	children: ReactNode;
	onClick?: () => void;
	type?: "button" | "submit" | "reset";
	disabled?: boolean;
};

export const FormSecondaryButton: FC<Props> = ({
	children,
	onClick,
	type = "button",
	disabled,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			type={type}
			onClick={onClick}
			disabled={disabled}
			sx={{
				width: "100%",
				py: 1.5,
				border: `1px solid ${theme.palette.grey[200]}`,
				color: theme.palette.grey[700],
				fontWeight: 500,
				fontSize: 16,
				borderRadius: "16px",
				transition: "transform 120ms ease-out",
				"&:active": { transform: "scale(0.97)" },
				"&.Mui-disabled": { opacity: 0.5 },
			}}
		>
			{children}
		</ButtonBase>
	);
};
